if (typeof Object.getDescendant != 'function') {
    Object.getDescendant = function (obj, map) {
        if (map == '') {
            return obj;
        }

        var props = map.split('.')
            , length = props.length
            , i = 0;

        while (obj && i < length) {
            obj = obj[props[i]];
            i++;
        }

        return obj;
    };
}

if (typeof Object.getLength != 'function') {
    Object.getLength = function (obj) {
        var length = 0;
        for (var p in obj) {
            ++length;
        }
        return length;
    };
}

if (typeof Object.isEmpty != 'function') {
    Object.isEmpty = function (obj) {
        return obj === null || obj === undefined || (Object.isArray(obj) && !obj.length) || (Object.isObject(obj) && Object.getLength(obj) === 0) || obj === '' ;
    };
}

if (typeof Object.isArray != 'function') {
    Object.isArray = function (obj) {
        return Object.prototype.toString.call(obj) == '[object Array]';
    };
}

if (typeof Array.isEqual != 'function') {
    Array.isEqual = function (arr1, arr2) {
        return arr1 && arr2 && arr1.length == arr2.length &&
            arr1.every(function(arr1Item, i) { return arr1Item == arr2[i] });
    };
}
if (typeof Object.deepCopyPruned != 'function') {
    Object.deepCopyPruned = function (obj) {
        return function prune(current) {
            Object.entries(current).forEach(function (obj) {
                var key = obj[0];
                var value = obj[1];
                if (Object.isEmpty(value) || (typeof value === 'object' && Object.isEmpty(prune(value)))) {
                    delete current[key];
                }
            });
            return current;

        }(JSON.parse(JSON.stringify(obj)));  // Do not modify the original object, create a clone instead
    }
}

if (typeof Object.isObject != 'function') {
    Object.isObject = function (obj) {
        return Object.prototype.toString.call(obj) === '[object Object]';
    };
}

if (typeof Object.serialize != 'function') {
    Object.serialize = function (obj) {
        return Object.keys(obj).reduce(function(a,k){a.push(k+'='+encodeURIComponent(obj[k]));return a},[]).join('&')
    }
}

if (typeof Date.convertDuration != 'function') {
    Date.convertDuration = function (time, returnSecs) {
        time = time || 0
        var seconds = time,
            hour = Math.floor(parseInt(seconds) / 3600),
            minute = 0

        seconds -= hour * 3600
        minute = Math.floor(seconds / 60)
        seconds -= minute * 60

        if (hour == 0 && minute == 0 && (seconds > 9 || returnSecs)) {
            return seconds + 's'
        }

        return (hour >= 1 ? hour + 'h' + ' ' : '') + (minute < 10 ? (minute == 0 ? '0' + 'm' : '0' + minute + 'm') : minute + 'm')
    }
}

if (typeof Date.convertDurationClock != 'function') {
    Date.convertDurationClock = function (time, addSeconds) {
        time = time || 0
        var seconds = time,
            hour = Math.floor(parseInt(seconds) / 3600),
            minute = 0

        seconds -= hour * 3600
        minute = addSeconds ? Math.ceil(Math.floor(seconds / 60)) : Math.floor(seconds / 60)
        seconds -= minute * 60

        return (hour >= 10 ? hour : ('0' + hour)) + ':' + (minute >= 10 ? minute : ('0' + minute)) + (addSeconds ? (seconds >= 10 ? seconds : (':' + '0' + seconds)) : '')
    }
}

if (typeof Date.fromArray != 'function') {
    Date.fromArray = function (args, scope) {
        return new (Function.prototype.bind.apply(Date, [scope].concat(args)));
    }
}

if(typeof Number.getBytes != 'function'){
    Number.getBytes = function (value) {
        value = value || 0
        return parseInt(value / Math.pow(1024, 2))
    }
}
Array.prototype.swap = function (a, b) {
    this[a] = this.splice(b, 1, this[a])[0];
    return this;
}
